export type NestSpinnerSize =
  | "small"
  | "medium"
  | "large"
